import { Box, Button, Flexbox, Heading, Modal, ModalBody, Stack, StackRow } from "codekit";

const Turnsxxx = ({
  isOpen = false,
  onContinue,
  onTerminate,
  isLoading = false,
  continueMinutesText = "1 minuto",
}) => {
  if (!isOpen) return null;

  return (
    <Modal size="sm" isOpen offsetY={400}>
      <ModalBody size="xl">
        <Box textAlign="center">
          <Stack gap={7}>
            <Heading variant="heading-6">
              Su turno ha terminado, si requiere mantener su sesión por favor presione el botón <b>“Continuar”</b>,
              tendrá {continueMinutesText} adicional; de no ser así el botón <b>“Terminar”</b> cerrará su sesión y
              terminará su turno.
            </Heading>

            <StackRow forceWidth>
              <Flexbox justifyContent="center" alignItems="center" gap={4}>
                <Button
                  type="button"
                  variant="success"
                  size="2l"
                  minWidth={180}
                  onClick={onContinue}
                  disabled={isLoading}
                >
                  Continuar
                </Button>

                <Button
                  type="button"
                  variant="primary-bold"
                  size="2l"
                  minWidth={180}
                  onClick={onTerminate}
                  isLoading={isLoading}
                >
                  Terminar
                </Button>
              </Flexbox>
            </StackRow>
          </Stack>
        </Box>
      </ModalBody>
    </Modal>
  );
};

export default Turnsxxx;
